// extracted by mini-css-extract-plugin
export default {"card":"card__uNhk6","cardImage":"cardImage__TpLTl","cardContent":"cardContent__p31_6"};